import Image from "next/image";
import error from "@/assets/images/error.png";

import styles from "./styles.module.scss";

const Error = () => {
  return (
    <div className={styles.card}>
      <Image
        src={error}
        alt="Error"
        width={60}
        height={60}
        className={styles.image}
      />
      <p className={styles.description}>Something went wrong</p>
    </div>
  );
};

export default Error;
